export const GOOGLE_BUTTON = "googleButton";
export const GOT = "got";
export const NONE = "none";

export const GOOGLE_BUTTON_STATES = [GOOGLE_BUTTON] as const;

export const STATES = [GOOGLE_BUTTON, GOT, NONE] as const;
